import React from "react";
import PropTypes from "prop-types";
import {Search} from "Components/Search/";

let SearchPage = ({
  searchModel,
  Heading,
  SearchText,
  theme,
  Breadcrumbs,
  ShowMoreText,
}) => {
  return (
    <>
       {/*<BreadcrumbsComp Items={Breadcrumbs} />*/}
      <Search {...{ ShowMoreText, SearchText, Heading }} {...searchModel} />
    </>
  );
};

SearchPage.propTypes = {
  Heading: PropTypes.string,
};

export default SearchPage;
